import React from 'react';
import { Ticker } from '../Ticker/Ticker/Ticker';

function RunningText(props: any) {
    return <Ticker data={{ text: props.text }} />;
}

export { RunningText };
